package com.arena_web.ui.sections.eventdetail

import androidx.compose.runtime.Composable
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.AppColors
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

/**
 * Celebration headline shown above the info banner on completed events
 * (non-Pro flow). Pro events use the segmented `MatchCenterTabs` instead.
 *
 * Spec: Figma node 7896:90245.
 */
@Composable
fun MatchEndedHeader(modifier: Modifier = Modifier) {
    val t = LocalAppStrings.current
    Column(
        modifier = modifier.fillMaxWidth().sGap(18),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            t.eventMatchEndedTitle,
            modifier = Modifier
                .sFontSize(46)
                .fontWeight(FontWeight.SemiBold)
                .sLineHeight(46)
                .color(AppColors.Text.Secondary)
                .styleModifier {
                    property("letter-spacing", s(1.38))
                    property("text-align", "center")
                    property("font-family", "Urbanist, sans-serif")
                }
        )
        SpanText(
            t.eventMatchEndedSubtitle,
            modifier = Modifier
                .sFontSize(32)
                .fontWeight(FontWeight.Medium)
                .sLineHeight(38)
                .color(AppColors.Text.Secondary)
                .styleModifier {
                    property("letter-spacing", s(0.64))
                    property("text-align", "center")
                    property("font-family", "Urbanist, sans-serif")
                }
        )
    }
}
